import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FormikErrors } from 'formik';
import { Modal } from '@whitelabel/component-library';
import { SOURCE_EMAIL, SOURCE, SOURCE_SMS } from '@whitelabel/xcover-shared/helpers/constants';
import Signup from '../Signup/Signup';
import { login, confirmUnmaskedSignUp } from '../../actions';

import useSignupModal from './useSignupModal';

interface ISignUpModal {
  openLoginModal: () => void;
}

interface IValues {
  email: string;
  password: string;
  phone: string;
}

interface IOnSignupSubmitParams {
  values: IValues;
  setSubmitting: (val: boolean) => void;
  setErrors: (errors: FormikErrors<IValues>) => void;
}

const SignupModal = ({ openLoginModal }: ISignUpModal): JSX.Element | null => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const id = urlParams.get('id') || '';
  const signupToken = urlParams.get('signup_token') || '';
  const source = urlParams.get(SOURCE) || SOURCE_EMAIL;
  const [isOpen, toggle] = useSignupModal(openLoginModal);

  const onSubmitOnModal = ({ values, setSubmitting, setErrors }: IOnSignupSubmitParams) => {
    setSubmitting(true);
    const onSignupSuccess = () => {
      dispatch(
        login({
          cognitoUserID: id,
          password: values.password,
          callbackOnSuccess: () => {
            setSubmitting(false);
            toggle();
          },
        }),
      );
    };

    const onSignupError = () => {
      setSubmitting(false);
      setErrors({ showCommonError: true } as FormikErrors<IValues>);
    };

    dispatch(
      confirmUnmaskedSignUp({
        ...values,
        id,
        source,
        unmaskedSignupToken: signupToken,
        onSuccess: onSignupSuccess,
        onError: onSignupError,
      }),
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      body={
        <Signup
          id={id}
          source={source as typeof SOURCE_SMS | typeof SOURCE_EMAIL}
          onSubmitOnModal={onSubmitOnModal}
          autoFocusPasswordField={false}
        />
      }
    />
  );
};

export default SignupModal;
